import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';
import type { BariPreGroupSessionData } from '@common/validation/customControls/bariPre/bariPreGroupSession/v1/bariPreGroupSessionSchemaV1';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { PatientPresence } from '@common/customControls/bariatrics';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { addAanwezigheidComponent } from '../../../bariatrics/readFormComponents';

export function BariPreGroupSessionRead(): JSX.Element {
    const { processActivity, readSections } = useProcessActivityReadContext<BariPreGroupSessionData>();

    return (
        <>
            <ReadForm components={getComponents()} />
            {processActivity.customControlData.aanwezigheid === PatientPresence.present && (
                <Alert appearance="success">
                    De patiënt is overgedragen aan het Obesitas Centrum Amsterdam. Er is een bericht naar de huisarts en
                    het OCA gestuurd.
                </Alert>
            )}
        </>
    );

    function getComponents(): ComponentsMap {
        const map: ComponentsMap = new Map();
        addAanwezigheidComponent<BariPreGroupSessionData>(readSections, map);

        return map;
    }
}
